import React, { useContext, useEffect, useState, useRef } from 'react';
import './Mainpage.css';
import WelcomeMessage from '../../components/WelcomeMessage/WelcomeMessage';
import AddButton from '../../components/AddButton/AddButton';
import ToggleSwitch from '../../components/ToggleSwitch/ToggleSwitch';
import TransactionCard from '../../components/TransactionCard/TransactionCard';
import RentalModal from '../../components/RentalModal/RentalModal';
import { MallContext } from '../../MallContext';
import Services from '../../services/Services';
import { useLanguage } from '../../LanguageProvider';
import { TbGift, TbInfoCircle, TbCalendarEvent } from "react-icons/tb";
import {
  isPetCampaignPoi,
  PET_CAMPAIGN_BANNER_LABEL,
  PET_CAMPAIGN_CODE,
  PET_CAMPAIGN_DESCRIPTION,
  PET_CAMPAIGN_TITLE,
  PET_CAMPAIGN_VALIDITY
} from "../../utils/petCampaign";

export default function Mainpage() {
  const { getTranslation } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const [isCampaignTooltipOpen, setIsCampaignTooltipOpen] = useState(false);
  const { token, poiID } = useContext(MallContext);
  const [userName] = useState(localStorage.getItem('name'));
  const [userLastname] = useState(localStorage.getItem('lastname'));
  const [userEmail] = useState(localStorage.getItem('email'));
  const [transactions, setTransactions] = useState([]);
  const [filteredTransactions, setFilteredTransactions] = useState([]);
  const [transactionType, setTransactionType] = useState("active");
  const [cargoCourierRequests, setCargoCourierRequests] = useState([]);
  const [activeTab] = useState('pet'); // 'pet' veya 'cargo'

  const intervalRef = useRef();
  const campaignTooltipRef = useRef(null);

  const formatTimeHM = (timestampInSeconds) => {
    const date = new Date(timestampInSeconds * 1000);
    let hours = date.getHours();
    let minutes = date.getMinutes();

    const formattedHours = hours < 10 ? `0${hours}` : hours;
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

    return `${formattedHours}:${formattedMinutes}`;
  };

  const formatTime = (seconds) => {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return `${hrs}:${mins < 10 ? '0' : ''}${mins}:${secs < 10 ? '0' : ''}${secs}`;
  };

  const getMyList = () => {
    Services.GetMyOrders(token, localStorage.customerID, poiID)
      .then((res) => {
        if (res.data.status) {
          let mappedData = res.data.result.map((item) => ({
            ...item,
            id: item?.id,
            type: item?.type,
            status: item?.status,
            vehicleNo: item?.vehicleID ? item?.vehicleID : '-',
            createdDateTime: parseInt(item?.createdDateTime),
            willDeliverDateTime: parseInt(item?.willDeliverDateTime),
          }));
          mappedData = mappedData.filter(i => i.isPaid === "1")
          setTransactions(mappedData);
          setFilteredTransactions(mappedData.filter(i => ((i.status === "3" || i.status === "4") && i.type !== "gift") || (i.type === "gift" && i.status === "3"))); // default: aktif işlemler
        }
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    getMyList();
  }, [token, cargoCourierRequests]);

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setTransactions((prev) => {
        const updated = prev.map((item) => {
          const now = Math.floor(Date.now() / 1000);
          if (item?.status === "4") {
            if (now > item?.willDeliverDateTime) {
              return {
                ...item,
                elapsedTime: formatTime(now - item?.confirmedDateTime),
                remainingTime: "00:00:00",
                passedTime: formatTime(now - item?.willDeliverDateTime),
                isExpired: true
              };
            } else {
              return {
                ...item,
                elapsedTime: formatTime(now - item?.confirmedDateTime),
                remainingTime: formatTime(item?.willDeliverDateTime - now),
                passedTime: "00:00:00",
                isExpired: false
              };
            }
          } else if (item?.status === "1") {
            if (item?.completedDateTime > item?.willDeliverDateTime) {
              return {
                ...item,
                elapsedTime: formatTime(item?.completedDateTime - item?.confirmedDateTime),
                passedTime: formatTime(item?.completedDateTime - item?.willDeliverDateTime),
                remainingTime: "00:00:00",
                isExpired: true
              };
            } else {
              return {
                ...item,
                elapsedTime: formatTime(item?.completedDateTime - item?.confirmedDateTime),
                passedTime: "00:00:00",
                remainingTime: "00:00:00",
                isExpired: false
              };
            }
          } else if (item?.status === "3") {
            return {
              ...item,
              elapsedTime: "00:00:00",
              passedTime: "00:00:00",
              remainingTime: "00:00:00",
              isExpired: false
            };
          } else {
            return item;
          }
        });
        if (transactionType === "active") {
          setFilteredTransactions(
            updated.filter((item) => ((item.status === "3" || item.status === "4") && item.type !== "gift") || (item.type === "gift" && item.status === "3"))
          );
        }
        else {
          setFilteredTransactions(
            updated.filter((item) => item.status === "1" || (item.status === "4" && item.type === "gift"))
          );
        }
        return updated;
      });
    }, 1000);

    return () => clearInterval(intervalRef.current);
  }, [transactionType]);

  useEffect(() => {
    if (!isCampaignTooltipOpen) return undefined;

    const handleOutsideClick = (event) => {
      if (!campaignTooltipRef.current?.contains(event.target)) {
        setIsCampaignTooltipOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    document.addEventListener("touchstart", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
      document.removeEventListener("touchstart", handleOutsideClick);
    };
  }, [isCampaignTooltipOpen]);


  const handleToggle = (index) => {
    if (index === 0) {
      setFilteredTransactions(transactions.filter(item => ((item.status === "3" || item.status === "4") && item.type !== "gift") || (item.type === "gift" && item.status === "3")));
      setTransactionType("active")
    } else if (index === 1) {
      setFilteredTransactions(transactions.filter(item => item.status === "1" || (item.status === "4" && item.type === "gift")));
      setTransactionType("passive")
    }
  };

  // Yeni talep ekleme fonksiyonu
  const handleNewCargoCourierRequest = (request) => {
    setCargoCourierRequests(prev => [request, ...prev]);
  };

  const hasActivePetCampaignTransaction = transactions.some(
    (item) => item?.type === "pet-car" && (item?.status === "3" || item?.status === "4")
  );

  const shouldShowCampaignCard = isPetCampaignPoi(poiID);
  return (
    <div className="user-card">
      <div className="avatar">{userName[0] + userLastname[0]}</div>
      <span className="user-name">{userName + ' ' + userLastname}</span>
      <span className="user-email">{userEmail ? userEmail : ''}</span>

      <div
        style={{
          width: '100%',
          justifyContent: 'center',
          display: 'flex',
          borderTop: '1px solid rgba(233, 233, 233, 1)',
          marginTop: '7px',
        }}
      >
        <WelcomeMessage style={{ marginTop: '16px' }} />
      </div>

      <div style={{ width: '100%', padding: '14px', boxSizing: 'border-box' }}>
        <AddButton onClick={() => setIsOpen(true)} label={getTranslation("createRequest")} style={{ width: '100%' }} />
      </div>

      {shouldShowCampaignCard && (
        <div className="campaign-card-wrapper">
          {hasActivePetCampaignTransaction ? (
            <div className="campaign-banner">
              <div className="campaign-banner-left">
                <div className="campaign-banner-icon">
                  <TbGift size={18} />
                </div>
                <span className="campaign-banner-label">
                  {getTranslation("campaignBannerLabel") || PET_CAMPAIGN_BANNER_LABEL}
                </span>
              </div>
              <span className="campaign-banner-code">{PET_CAMPAIGN_CODE}</span>
            </div>
          ) : (
            <div className="campaign-promo-wrapper">
              <div className="campaign-card" ref={campaignTooltipRef}>
                <div className="campaign-card-aside">
                  <div className="campaign-card-icon">
                    <TbGift size={22} />
                  </div>
                </div>
                <div className="campaign-card-main">
                  <div className="campaign-card-header">
                    <span className="campaign-card-header-label">
                      {getTranslation("campaignExclusiveLabel") || "Size Özel"}
                    </span>
                    <button
                      type="button"
                      className="campaign-card-info-button"
                      onClick={() =>
                        setIsCampaignTooltipOpen((prev) => !prev)
                      }
                    >
                      <TbInfoCircle size={18} />
                    </button>
                  </div>
                  {isCampaignTooltipOpen && (
                    <div className="campaign-promo-tooltip">
                      {getTranslation("campaignHiddenCodeHint") || "Kod, aktif işleminiz oluştuktan sonra görüntülenir."}
                    </div>
                  )}
                  <div className="campaign-card-title">{PET_CAMPAIGN_TITLE}</div>
                  <div className="campaign-card-description">
                    {PET_CAMPAIGN_DESCRIPTION}
                  </div>
                  <div className="campaign-card-footer">
                    <span className="campaign-card-date">
                      <TbCalendarEvent size={13} />
                      {PET_CAMPAIGN_VALIDITY}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      <div style={{ width: '100%', padding: '14px', boxSizing: 'border-box' }}>
        <ToggleSwitch labels={[getTranslation("activeTransactions"), getTranslation("pastTransactions")]} onClick={handleToggle} />
      </div>

      {/* <div style={{ width: '100%', padding: '14px', boxSizing: 'border-box', display: 'flex', gap: 8, marginBottom: 8 }}>
        <button
          className={activeTab === 'pet' ? 'tab-active' : 'tab-inactive'}
          style={{ flex: 1, padding: '12px', borderRadius: 8, border: 'none', fontWeight: 500, fontSize: 15, fontFamily:'Plus Jakarta Sans', background: activeTab === 'pet' ? '#DA3831' : '#F3F3F3', color: activeTab === 'pet' ? '#fff' : '#23272E', cursor: 'pointer' }}
          onClick={() => setActiveTab('pet')}
        >
          {getTranslation('petRequest')}
        </button>
      </div> */}

      {/* 
      <div style={{ width: '100%', padding: '14px', boxSizing: 'border-box', display: 'flex', gap: 8, marginBottom: 8 }}>
        <button
          className={activeTab === 'pet' ? 'tab-active' : 'tab-inactive'}
          style={{ flex: 1, padding: '12px', borderRadius: 8, border: 'none', fontWeight: 600, fontSize: 16, background: activeTab === 'pet' ? '#DA3831' : '#F3F3F3', color: activeTab === 'pet' ? '#fff' : '#23272E', cursor: 'pointer' }}
          onClick={() => setActiveTab('pet')}
        >
          {getTranslation('petRequest')}
        </button>
        <button
          className={activeTab === 'cargo' ? 'tab-active' : 'tab-inactive'}
          style={{ flex: 1, padding: '12px', borderRadius: 8, border: 'none', fontWeight: 600, fontSize: 16, background: activeTab === 'cargo' ? '#DA3831' : '#F3F3F3', color: activeTab === 'cargo' ? '#fff' : '#23272E', cursor: 'pointer' }}
          onClick={() => setActiveTab('cargo')}
        >
          {getTranslation('CourierCargoRequest')}
        </button>
      </div> */}

      {activeTab === 'pet' && (
        filteredTransactions.length > 0 &&
        <div style={{ width: '100%', padding: '14px', boxSizing: 'border-box' }}>
          {filteredTransactions.map((item) => (
            <TransactionCard
              key={item.id}
              type={item?.type}
              status={item?.status}
              vehicleNo={item?.vehicleNo}
              elapsedTime={item?.elapsedTime}
              remainingTime={item?.remainingTime}
              serviceType={item?.type}
              createdDateTime={formatTimeHM(item?.createdDateTime)}
              willDeliverDateTime={formatTimeHM(item?.willDeliverDateTime)}
              originalWillDeliverDateTime={item?.willDeliverDateTime}
              price={item?.price}
              isExpired={item?.isExpired}
              packageCount={item?.type === "gift" ? item?.packageCount : null}
              requestID={item?.requestID}
            />
          ))}
        </div>
      )}

      {activeTab === 'cargo' && (
        <div style={{ width: '100%', padding: '14px', boxSizing: 'border-box' }}>
          {cargoCourierRequests.length === 0 && (
            <div style={{ color: '#B0B0B0', textAlign: 'center', marginTop: 32 }}>Henüz bir kargo/kurye talebiniz yok.</div>
          )}
          {cargoCourierRequests.map((req) => (
            <div key={req.id} style={{ border: '1px solid #D0D5DD', borderRadius: 8, padding: 16, marginBottom: 12, background: '#fff', display: 'flex', flexDirection: 'column', gap: 4 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontWeight: 600, color: '#23272E' }}>{req.selectedCompany} Gönderim Talebi</span>
                <span style={{ color: '#F2994A', fontWeight: 600, fontSize: 15 }}>Kuryeniz yolda</span>
              </div>
              <div style={{ color: '#6B7280', fontSize: 15, textAlign: 'left', marginTop: 4 }}>Gönderi Kodu: {req.id}</div>
              <div style={{ color: '#6B7280', fontSize: 13, textAlign: 'left', marginTop: 10 }}>{req.date}</div>
            </div>
          ))}
        </div>
      )}

      <RentalModal setIsOpen={setIsOpen} isOpen={isOpen} onRequestCreated={handleNewCargoCourierRequest} />
    </div>
  );
}
